import LTag from './LTag.vue'

export default (Vue) => {
  Vue.component(LTag.name, LTag)
}
